export enum TimelineResolution {
  Weekly = 1,
}
